import React, { useState, useEffect } from 'react';
import AdminSidebar from './AdminSidebar';
import { getPaymentQueue } from '../../services/adminService';

export default function AdminLayout({ children, title }) {
  const [pendingPayments, setPendingPayments] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen]   = useState(false);

  useEffect(() => {
    getPaymentQueue({ status: 'held', limit: 1 })
      .then(res => setPendingPayments(res.total || 0))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-surface flex">
      {/* Desktop sidebar */}
      <div className="hidden md:block">
        <AdminSidebar pendingPayments={pendingPayments} />
      </div>

      {/* Mobile sidebar overlay */}
      {mobileMenuOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-30 md:hidden"
            onClick={() => setMobileMenuOpen(false)}
          />
          <div className="md:hidden">
            <AdminSidebar pendingPayments={pendingPayments} />
          </div>
        </>
      )}

      {/* Main content */}
      <div className="flex-1 md:ml-60 flex flex-col min-h-screen">
        {/* Top bar */}
        <header className="sticky top-0 z-20 h-14 bg-white border-b border-border flex items-center px-4 gap-3">
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="md:hidden btn-icon"
          >
            <i className="fa-solid fa-bars text-text-primary" />
          </button>
          <h1 className="text-base font-semibold text-text-primary font-heading">{title}</h1>
          {pendingPayments > 0 && (
            <span className="ml-auto flex items-center gap-1.5 text-xs font-semibold text-danger bg-red-50 px-3 py-1 rounded-full border border-red-200">
              <i className="fa-solid fa-clock text-[10px]" />
              {pendingPayments} payment{pendingPayments !== 1 ? 's' : ''} pending
            </span>
          )}
        </header>

        {/* Page content */}
        <main className="flex-1 p-4 md:p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
